import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import './LoginForm.scss';

interface LoginFormProps {
  onForgotPassword?: () => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onForgotPassword }) => {
  const { t } = useTranslation('auth');
  const { login } = useAuth();
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const isFormValid = formData.username && formData.password;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Basic validation
    if (!formData.username || !formData.password) {
      setError(t('loginForm.error.allFieldsRequired'));
      return;
    }

    try {
      setLoading(true);
      await login(formData);
    } catch (err) {
      setError(t('loginForm.error.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form-container">
      <h2>{t('loginForm.title')}</h2>
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">{t('loginForm.username')}</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">{t('loginForm.password')}</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            disabled={loading}
          />
          <button 
            type="button" 
            className="forgot-password" 
            onClick={onForgotPassword}
          >
            {t('loginForm.forgotPassword')}
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}

        <button
          type="submit"
          className={`login-button ${isFormValid ? 'valid' : ''}`}
          disabled={loading}
        >
          {loading
            ? t('loginForm.loggingIn')
            : t('loginForm.login')}
        </button>


      </form>
    </div>
  );
};

